import HeadPt from './Head.pt.json'
import HeadEn from './Head.en.json'
import HeadEs from './Head.es.json'
import DifferentialsPt from './Differentials.pt.json'
import DifferentialsEn from './Differentials.en.json'
import DifferentialsEs from './Differentials.es.json'
import LocationPt from './Location.pt.json'
import LocationEn from './Location.en.json'
import LocationEs from './Location.es.json'
import ApartmentsPt from './Apartments.pt.json'
import ApartmentsEn from './Apartments.en.json'
import ApartmentsEs from './Apartments.es.json'
import CommonAreasPt from './CommonAreas.pt.json'
import CommonAreasEn from './CommonAreas.en.json'
import CommonAreasEs from './CommonAreas.es.json'
import DesignersPt from './Designers.pt.json'
import DesignersEn from './Designers.en.json'
import DesignersEs from './Designers.es.json'
import DimasPt from './Dimas.pt.json'
import DimasEn from './Dimas.en.json'
import DimasEs from './Dimas.es.json'
import DormitoriesPt from './Dormitories.pt.json'
import DormitoriesEn from './Dormitories.en.json'
import DormitoriesEs from './Dormitories.es.json'
import DVertResidenceClubPt from './DVertResidenceClub.pt.json'
import DVertResidenceClubEs from './DVertResidenceClub.es.json'
import DVertResidenceClubEn from './DVertResidenceClub.en.json'
import FooterPt from './Footer.pt.json'
import FooterEn from './Footer.en.json'
import FooterEs from './Footer.es.json'
import GreenPt from './Green.pt.json'
import GreenEn from './Green.en.json'
import GreenEs from './Green.es.json'
import HeroPt from './Hero.pt.json'
import HeroEn from './Hero.en.json'
import HeroEs from './Hero.es.json'
import ResidenceClubPt from './ResidenceClub.pt.json'
import ResidenceClubEn from './ResidenceClub.en.json'
import ResidenceClubEs from './ResidenceClub.es.json'
import SpacesPt from './Spaces.pt.json'
import SpacesEn from './Spaces.en.json'
import SpacesEs from './Spaces.es.json'
import SustainablePt from './Sustainable.pt.json'
import SustainableEn from './Sustainable.en.json'
import SustainableEs from './Sustainable.es.json'
import PlantsPt from './Plants.pt.json'
import PlantsEn from './Plants.en.json'
import PlantsEs from './Plants.es.json'
import ContactPt from './Contact.pt.json'
import ContactEn from './Contact.en.json'
import ContactEs from './Contact.es.json'
import SustainableDataPt from './SustainableData.pt.json'
import SustainableDataEn from './SustainableData.en.json'
import SustainableDataEs from './SustainableData.es.json'
import CommonAreasDataPt from './CommonAreasData.pt.json'
import CommonAreasDataEn from './CommonAreasData.en.json'
import CommonAreasDataEs from './CommonAreasData.es.json'
import HamburguerPt from './Hamburguer.pt.json'
import HamburguerEn from './Hamburguer.en.json'
import HamburguerEs from './Hamburguer.es.json'
import MenuBarPt from './MenuBar.pt.json'
import MenuBarEn from './MenuBar.en.json'
import MenuBarEs from './MenuBar.es.json'
import DifferentialsSVGPt from './DifferentialsSVG.pt.json'
import DifferentialsSVGEn from './DifferentialsSVG.en.json'
import DifferentialsSVGEs from './DifferentialsSVG.es.json'
import WelcomePt from './Welcome.pt.json'
import WelcomeEn from './Welcome.en.json'
import WelcomeEs from './Welcome.es.json'
import DVertPt from './DVert.pt.json'
import DVertEn from './DVert.en.json'
import DVertEs from './DVert.es.json'
import EbookPt from './Ebook.pt.json'
import EbookEn from './Ebook.en.json'
import EbookEs from './Ebook.es.json'
import NegotiationPt from './Negotiation.pt.json'
import NegotiationEn from './Negotiation.en.json'
import NegotiationEs from './Negotiation.es.json'
import SuccessPt from './Success.pt.json'
import SuccessEn from './Success.en.json'
import SuccessEs from './Success.es.json'

import { translatePath as _translatePath } from './translatePath'

export const resources = {
  pt: {
    translation: {
      Head: HeadPt,
      Differentials: DifferentialsPt,
      Location: LocationPt,
      Apartments: ApartmentsPt,
      CommonAreas: CommonAreasPt,
      Designers: DesignersPt,
      Dimas: DimasPt,
      Dormitories: DormitoriesPt,
      DVertResidenceClub: DVertResidenceClubPt,
      Footer: FooterPt,
      Green: GreenPt,
      Hero: HeroPt,
      ResidenceClub: ResidenceClubPt,
      Spaces: SpacesPt,
      Sustainable: SustainablePt,
      Plants: PlantsPt,
      Contact: ContactPt,
      SustainableData: SustainableDataPt,
      CommonAreasData: CommonAreasDataPt,
      Hamburguer: HamburguerPt,
      MenuBar: MenuBarPt,
      DifferentialsSVG: DifferentialsSVGPt,
      Welcome: WelcomePt,
      DVert: DVertPt,
      Ebook: EbookPt,
      Negotiation: NegotiationPt,
      Success: SuccessPt,
    },
  },
  en: {
    translation: {
      Head: HeadEn,
      Differentials: DifferentialsEn,
      Location: LocationEn,
      Apartments: ApartmentsEn,
      CommonAreas: CommonAreasEn,
      Designers: DesignersEn,
      Dimas: DimasEn,
      Dormitories: DormitoriesEn,
      DVertResidenceClub: DVertResidenceClubEn,
      Footer: FooterEn,
      Green: GreenEn,
      Hero: HeroEn,
      ResidenceClub: ResidenceClubEn,
      Spaces: SpacesEn,
      Sustainable: SustainableEn,
      Plants: PlantsEn,
      Contact: ContactEn,
      SustainableData: SustainableDataEn,
      CommonAreasData: CommonAreasDataEn,
      Hamburguer: HamburguerEn,
      MenuBar: MenuBarEn,
      DifferentialsSVG: DifferentialsSVGEn,
      Welcome: WelcomeEn,
      DVert: DVertEn,
      Ebook: EbookEn,
      Negotiation: NegotiationEn,
      Success: SuccessEn,
    },
  },
  es: {
    translation: {
      Head: HeadEs,
      Differentials: DifferentialsEs,
      Location: LocationEs,
      Apartments: ApartmentsEs,
      CommonAreas: CommonAreasEs,
      Designers: DesignersEs,
      Dimas: DimasEs,
      Dormitories: DormitoriesEs,
      DVertResidenceClub: DVertResidenceClubEs,
      Footer: FooterEs,
      Green: GreenEs,
      Hero: HeroEs,
      ResidenceClub: ResidenceClubEs,
      Spaces: SpacesEs,
      Sustainable: SustainableEs,
      Plants: PlantsEs,
      Contact: ContactEs,
      SustainableData: SustainableDataEs,
      CommonAreasData: CommonAreasDataEs,
      Hamburguer: HamburguerEs,
      MenuBar: MenuBarEs,
      DifferentialsSVG: DifferentialsSVGEs,
      Welcome: WelcomeEs,
      DVert: DVertEs,
      Ebook: EbookEs,
      Negotiation: NegotiationEs,
      Success: SuccessEs,
    },
  },
}

export const translatePath = _translatePath as (path: string) => string
